import React from 'react';

import golf from '../images/golf.png';
import { Section, H3 } from './Layout';

export default () => {
  return (
    <Section>
      <div>
        <img src={golf} alt="Taylor Fuqua golf" />
      </div>
      <div>
        <H3>About Me</H3>
        Hello, my name is Taylor Fuqua and I am a 27-year-old from La Plata, Md. I am an avid sports fan, attended
        college on a golf scholarship, and have a passion for creating webpages that load as fast as possible.
      </div>
    </Section>
  );
};



// WEBPACK FOOTER //
// ./src/components/About.js